// extracted by mini-css-extract-plugin
module.exports = {"viewport":"TaskSVG_viewport__ex_Ye","content":"TaskSVG_content__POPBj","appear":"TaskSVG_appear__RfFOx"};